if (!customElements.get('main-bfcm')) {
  customElements.define('main-bfcm', class MainBfcm extends HTMLElement {
    constructor() {
      super();
      this.filterElements = this.querySelectorAll(".main-bfcm-filter-item");
      this.initEvents();
    }

    initEvents() {
      this.filterElements.forEach((el) => {
        el.addEventListener("click", () => {
          this.filterClickHandler(el);
        });
      });
    }

    filterClickHandler(element) {
      this.filterElements.forEach(el => el.classList.remove("active"));
      element.classList.add("active");
      const itemId = element.dataset.id;

      if (element.classList.contains("first-class")) {
        this.querySelectorAll(".main-bfcm-filter-content").forEach((el) => {
          el.classList.remove("hide");
          // Only animate if currently hidden
          if (el.style.display === 'none' || el.offsetHeight === 0 || el.classList.contains('sliding-up')) {
            this.slideDown(el);
          }
        });
      } else {
        this.querySelectorAll(".main-bfcm-filter-content").forEach((el) => {
          if (el.id == itemId) {
            el.classList.remove("hide");
            // Only animate if currently hidden
            if (el.style.display === 'none' || el.offsetHeight === 0 || el.classList.contains('sliding-up')) {
              this.slideDown(el);
            }
          } else {
            el.classList.add("hide");
            // Only animate if currently visible
            if (el.style.display !== 'none' && el.offsetHeight > 0 && !el.classList.contains('sliding-up')) {
              this.slideUp(el);
            }
          }
        });
      }
    }

    slideDown(element) {
      // Cancel any ongoing animation
      if (element.rafId) {
        cancelAnimationFrame(element.rafId);
        delete element.rafId;
      }

      // Remove sliding-up class if present
      element.classList.remove('sliding-up');

      // Skip if already fully expanded with no height constraint
      if (element.style.display === 'block' && !element.style.height && element.offsetHeight > 0) {
        return;
      }

      // Measure target height without showing
      const originalDisplay = element.style.display;
      const originalVisibility = element.style.visibility;
      const originalPosition = element.style.position;
      const originalHeight = element.style.height;

      element.style.visibility = 'hidden';
      element.style.position = 'absolute';
      element.style.display = 'block';
      element.style.height = '';
      element.style.overflow = '';
      
      const targetHeight = element.scrollHeight;
      
      // Restore and set starting position
      element.style.position = originalPosition;
      element.style.visibility = originalVisibility;
      element.style.display = 'block';
      element.style.overflow = 'hidden';
      
      // Start from current height (could be mid-animation)
      const startHeight = element.offsetHeight || 0;
      element.style.height = startHeight + 'px';

      const duration = 400;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Ease out cubic
        const eased = 1 - Math.pow(1 - progress, 3);
        
        const newHeight = startHeight + ((targetHeight - startHeight) * eased);
        element.style.height = newHeight + 'px';
        
        if (progress < 1) {
          element.rafId = requestAnimationFrame(animate);
        } else {
          element.style.height = '';
          element.style.overflow = '';
          delete element.rafId;
        }
      };

      element.rafId = requestAnimationFrame(animate);
    }

    slideUp(element) {
      // Cancel any ongoing animation
      if (element.rafId) {
        cancelAnimationFrame(element.rafId);
        delete element.rafId;
      }

      // Add sliding-up class to track state
      element.classList.add('sliding-up');

      // Skip if already hidden
      if (element.style.display === 'none') {
        element.classList.remove('sliding-up');
        return;
      }

      // Start from current height (could be mid-animation)
      const startHeight = element.offsetHeight || element.scrollHeight;
      
      element.style.overflow = 'hidden';
      element.style.height = startHeight + 'px';

      const duration = 400;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Ease out cubic
        const eased = 1 - Math.pow(1 - progress, 3);
        
        element.style.height = (startHeight * (1 - eased)) + 'px';
        
        if (progress < 1) {
          element.rafId = requestAnimationFrame(animate);
        } else {
          element.style.display = 'none';
          element.style.height = '';
          element.style.overflow = '';
          element.classList.remove('sliding-up');
          delete element.rafId;
        }
      };

      element.rafId = requestAnimationFrame(animate);
    }
  });
}